import { QuotePaymentTermCodeFieldError } from '../quote-payment-term-code';
import { IQuotePaymentTermCodeFieldErrorData } from '../quote-payment-term-code.types';

export const mockQuotePaymentTermCodeFieldErrorData: IQuotePaymentTermCodeFieldErrorData = {
  code: ['Ensure this field has no more than 3 characters.']
};

export const mockQuotePaymentTermCodeFieldError = new QuotePaymentTermCodeFieldError(
  mockQuotePaymentTermCodeFieldErrorData
);
